// extracted by css-extract-rspack-plugin
export default {"modalContent":"To__p","modalHeader":"KSX5J","modalBody":"BgS57","modalFooter":"qY0RR"};